import React, { Component } from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase';
import AddFishForm from './AddFishForm';
import EditFishForm from './EditFishForm';
import Login from './Login';
import base, { firebaseApp } from '../base';

class Inventory extends Component {
  static propTypes = {
    fishes: PropTypes.object,
    updateFish: PropTypes.func,
    deleteFish: PropTypes.func,
    loadSampleFishes: PropTypes.func
  };

  state = {
    uid: null,
    owner: null,
    name: null,
    photo: null
  };

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      if(user) {
        this.authHandler({ user });
      }
    });
  };

  authHandler = async authData => {
    const store = await
    base.fetch(this.props.storeId, { context: this });

    console.log(store);

    if(!store.owner) {
      await base.post(`${this.props.storeId}/owner`, {data: authData.user.uid}
    )}

    this.setState({
      uid: authData.user.uid,
      owner: store.owner || authData.user.email,
      name: authData.user.displayName,
      photo: authData.user.photoURL

    })

    console.log(this.state);
  };

  authenticate = (provider) => {
    const authProvider = new firebase.auth[`${provider}AuthProvider`]();
    firebaseApp.auth().signInWithPopup(authProvider).then(this.authHandler);
  };

  logout = async () => {
    console.log('Loggin out!');
    await firebase.auth().signOut();
    this.setState({ uid: null });
  };

  goToStore = (e) => {
    this.props.history.push(`/store/fintastic`)
    console.log(this.props.storeId);
  };

  render(){
    const logout = <button onClick={this.logout}>Log Out!</button>;
    const goToStore = <button onClick={this.goToStore}>Preview Store</button>;

    if (!this.state.uid) {
      return <Login authenticate={this.authenticate} />;
    }

    if(this.state.uid !== this.state.owner) {
      return (
        <div>
          <p>Sorry you are not the owner!</p>
          {logout}
        </div>
      );
    }

    return(
      <div>
      <div className="user-profile">
        <img className="profile-pic user" src={this.state.photo} alt="user-image"></img>
        <p className="profile-name user">{this.state.name}</p>
      </div>
      <div className="inventory">
        <h2>Inventory</h2>
        {logout}
        {goToStore}
        {Object.keys(this.props.fishes).map(key => ( <EditFishForm
            key={key}
            index={key}
            fish={this.props.fishes[key]} updateFish={this.props.updateFish}
            deleteFish={this.props.deleteFish}
            />
        ))}
        <AddFishForm addFish={this.props.addFish}
        />
        <button onClick={this.props.loadSampleFishes}>Load Samples Fishes</button>
      </div>
      </div>
    );
  }
}

export default Inventory;



// WEBPACK FOOTER //
// ./src/components/Inventory.js